import React from "react"
import { Link } from "gatsby"
import RetinaImageWrapper from "../../../components/RetinaImage"
import * as styles from "./index.module.less"

export default ({ selectedMrs = [], slug = null }) => {
  return (
    <div className="container">
      <div className="space-profile-meeting-rooms bottom-line">
        <div className="row">
          <div className={`col-sm-12 ${styles.meeting_rooms_title_box}`}>
            <h2>Meeting Rooms</h2>
            <Link
              to={`/meeting-rooms${slug ? `#${slug}` : ""}`}
              className="btn btn-primary ms-auto"
            >
              Book Now
            </Link>
          </div>

          {selectedMrs.map((item, idx) => {
            return (
              <div
                className={`col-sm-6 col-md-${
                  selectedMrs.length === 3 ? "4" : "6"
                }`}
                key={item.id}
              >
                <div
                  className={`meeting-room inside-locations ${
                    idx === 0 ? "remove-margin" : ""
                  }`}
                >
                  <div className="img">
                    <RetinaImageWrapper
                      image={item.mrImage[0]}
                      retinaImage={item.mrImageRetina[0]}
                    />
                  </div>
                  <h4>{item.title}</h4>
                  {item.amenities && (
                    <div className="row">
                      <div className="col-sm-12">
                        <ul className="room-amenities">
                          {item.amenities.split("\n").map((text, idx) => (
                            <li key={idx}>{text}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
